import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {FiltersIcon} from '../../../components/icons'
import {remCalc} from '../../../theme/_utils'

const FiltersButton = ({buttonClick, activeFiltersCount}) => {
    const styles = useMultiStyleConfig('Filters')

    return (
        <Button
            leftIcon={
                <FiltersIcon {...styles.filterIcon} width={remCalc(16)} height={remCalc(16)} />
            }
            data-cs-label="filters"
            rightIcon={
                activeFiltersCount > 0 ? (
                    <Text {...styles.activeFiltersCount}>{activeFiltersCount}</Text>
                ) : null
            }
            background="background.neutral.default"
            variant="ghost-rounded"
            size="base"
            onClick={buttonClick}
            _focusVisible={{
                border: 'small',
                borderColor: 'button.border.primary-focused',
                borderStyle: 'solid',
            }}
        >
            <Text
                {...styles.filterText}
                color="foreground.neutral.default"
                textStyle="body-small"
                fontWeight="medium"
            >
                <Box as="span" {...styles.mobile}>
                    <FormattedMessage defaultMessage="Filter" id="product_list.button.filter" />
                </Box>
                <Box as="span" {...styles.desktop}>
                    <FormattedMessage
                        defaultMessage="All Filters"
                        id="product_list.button.all_filters"
                    />
                </Box>
            </Text>
        </Button>
    )
}
FiltersButton.propTypes = {
    buttonClick: PropTypes.func,
    activeFiltersCount: PropTypes.number,
}

export default FiltersButton
